import React, {useEffect, useRef, useState} from 'react';
import {Button} from "primereact/button";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslate} from "../useTranslate";
import {Avatar as PrimeAvatar} from "primereact/avatar";
import {OverlayPanel} from "primereact/overlaypanel";
import {logout} from "../../auth/auth-slice";
import {Dropdown} from "primereact/dropdown";
import {public_url, timestampToDate} from "../utils";
import Flag from "react-flagpack";
import 'react-flagpack/dist/style.css'
import {getSiteConfigs, setSiteConfigs} from "../storage";
import {fetchAppData} from "../app-slice";
import {MultiStateCheckbox} from "primereact/multistatecheckbox";
import LanguageItem from "./language-item";
import Avatar from "./avatar";
import Icon from "./icon";
import {useRealtime} from "../realtime/useRealtime";
import {useFocusSession} from "../focus/focus-session-context";
import ToolbarFocusStatus from "./toolbar-focus-status";
import NotificationBell from "./notification-bell";
import {useFocusClock} from "../focus/focus-clock";
import GlobalSearch from "./global-search/global-search";
import {useWorkspaceRole} from "../use-workspace-role";

function Toolbar({setVisibleSidebar, visibleSidebar, onTitleClicked, readOnly = false}) {
    const {config, pages, homePageIndex, workspaceMembershipData} = useSelector((state) => state.app);
    const {user} = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const location = useLocation();
    const translate = useTranslate();
    const navigate = useNavigate();
    const [currentPageIndex, setCurrentPageIndex] = useState(homePageIndex);
    const [showHomePageButton, setShowHomePageButton] = useState(false);
    const [wsConnected, setWsConnected] = useState(false);
    const userRef = useRef();
    const darkLightOptions = [{value:"dark", icon:"pi pi-moon"},{value:"light", icon:"pi pi-sun"}];
    const realTime = useRealtime();
    const focus = useFocusSession();
    const focusClockNow = useFocusClock(Boolean(focus.session));
    const focusElapsedSeconds = focus.session ? focus.getOwnElapsedSeconds(focusClockNow) : 0;
    // guests only reach goals and conversations, so they get no global search (the server refuses it too)
    const {role: workspaceRole} = useWorkspaceRole();
    const showSearch = Boolean(workspaceMembershipData?.workspace) && workspaceRole !== "guest";
    useEffect(()=>{

        const currentPageIndex = location.pathname==='/'?homePageIndex:pages.findIndex(e=>location.pathname===e['nav-url']);
        setCurrentPageIndex(currentPageIndex);
        setShowHomePageButton(currentPageIndex!==homePageIndex);
    },[location.pathname])

    return (
        <div className={"w-full surface-ground border-bottom-1 border-200 flex align-items-center p-2 justify-content-between h-4rem relative"}>
            <div className="flex align-items-center gap-2">
                {realTime.isConnected&&(<Icon icon="mi mi:cloud_sync"/>)}
                {config.sidebar?(<span className="pi pi-bars cursor-pointer" onClick={()=>{setVisibleSidebar(!visibleSidebar)}}/>):(showHomePageButton&&<span className="pi pi-chevron-right cursor-pointer" onClick={()=>{navigate("/")}}/>)}
                {/*<span className="yekan-bakh-font">{`${currentPageIndex>0?translate(pages[currentPageIndex].name):""}`}</span>*/}
                <div className="flex align-items-center gap-2 cursor-pointer" onClick={(e)=>{onTitleClicked?.(e)}}>
                    <span className="font-bold">{`${workspaceMembershipData?.workspace?.name??""}`}</span>
                    <i className="pi pi-cog text-xs text-500"/>
                </div>
            </div>
            {showSearch && <GlobalSearch/>}
            <div className="flex align-items-center gap-2">
                <ToolbarFocusStatus session={focus.session} elapsedSeconds={focusElapsedSeconds} translate={translate} onOpen={focus.openFocusMode}/>

                {config['dark-mode-switch']&&(
                    <div className="border-1 p-2 border-100 border-round flex gap-1 align-items-center ml-2">
                        <MultiStateCheckbox empty={false} value={config["dark-mode"]?"dark":"light"} defaultValue="light" onChange={(e) => {setSiteConfigs({...getSiteConfigs(), "dark-mode":e.value==="dark"}); dispatch(fetchAppData())}} options={darkLightOptions} optionValue="value" />
                        <span className="text-xs">{config["dark-mode"]?translate("dark"):translate("light")}</span>
                    </div>
                )}
                {config["multi-language"]&&<Dropdown panelClassName={`${config.dir}`} options={config['support-languages']} value={config['support-languages'][config['support-languages'].findIndex(l=>l.code===(getSiteConfigs()&&getSiteConfigs().language?getSiteConfigs().language.code:config.language))]} valueTemplate={(option, props)=>(<LanguageItem option={option} props={props} />)} itemTemplate={(option, props)=>(<LanguageItem option={option} props={props} />)} onChange={(e)=>{setSiteConfigs({...getSiteConfigs(), language:e.value}); dispatch(fetchAppData())}}/>}
                <NotificationBell readOnly={readOnly}/>

                {/*<PrimeAvatar icon={!user?.name&&"pi pi-user"} label={user?.name?.charAt(0).toUpperCase()} shape="circle" size="large" className="ml-2" onClick={(e) => userRef.current.toggle(e)}/>*/}
                <Avatar size="large" className="text-sm font-bold" memberData={user} onClick={(e) => userRef.current.toggle(e)}/>
                <OverlayPanel className="w-9rem" ref={userRef} pt={{content:()=>({className:"p-0"})}}>
                    <div className="flex flex-column gap-1">
                        {config['user-profile']&&(<Button className="p-2 text-xs p-button-text border-round-sm shadow-none" label={translate('user-account')} onClick={()=>{navigate('/user-account'); userRef.current.hide();}} />)}
                        <Button className="p-2 text-xs p-button-text border-round-sm shadow-none" label={translate('notification-settings')} onClick={()=>{navigate('/notification-settings'); userRef.current.hide();}} />
                        <Button className="p-2 text-xs p-button-text border-round-sm shadow-none" label={translate('sign-out')} onClick={()=>{dispatch(logout())}}/>
                    </div>
                </OverlayPanel>


            </div>


        </div>
    );
}

export default Toolbar;
